
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assignments/[slug]",
      function () {
        return require("private-next-pages/assignments/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/assignments/[slug]"])
      });
    }
  